import React from 'react';
import {svgIconWrapper} from '../svg-icon-wrapper';
import Quote from './icon-goal-quote.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return <Quote {...validProps} />;
}
SvgComponent.iconName = 'goal-quote';

export const GoalQuoteIcon = svgIconWrapper(SvgComponent);
